<template>
  <div class="mainContainer" v-loading="loading" element-loading-text="上传中">
    <nav-bar style="width: 100%" :type="type" />
    <div class="innerContainer">
      <div class="editContainer">
        <vue-tinymce v-model="content" :setting="setting" :setup="setup" />

        <div class="sourceListContainer">
          <div class="inputLabel">图片/视频</div>
          <div class="sourcesContainer">
            <ul class="graphList">
              <li v-for="(item, index) in resource_url" :key="index">
                <div class="thumbContainer">
                  <img :src="item.thumb" class="thumb" />
                  <img
                    src="../../assets/imageDelete.png"
                    class="deleteFn"
                    @click="graphDelete(index)"
                  />
                  <img
                    src="../../assets/videoIcon.png"
                    class="videoIcon"
                    v-if="isVideo == 1"
                  />
                </div>
              </li>
              <li
                v-show="
                  isVideo == -1 ||
                  (isVideo == 0 && resource_url.length < 18) ||
                  (isVideo == 1 && resource_url.length < 1)
                "
              >
                <div class="thumbContainer">
                  <el-upload
                    action="no"
                    accept="image/*,video/*"
                    :before-upload="onBeforeUpload"
                    :http-request="uploadFn"
                    class="uploadElemBox"
                  >
                    <img
                      src="../../assets/script/uploadF.png"
                      style="
                        width: 100%;
                        height: 100%;
                        border: 1px dashed #ccc;
                        border-radius: 6px;
                        position: absolute;
                        left: 0;
                        top: 0;
                      "
                    />
                  </el-upload>
                </div>
              </li>
            </ul>
            <div class="imgCount" v-if="isVideo == 0 || isVideo == -1">
              <span v-if="isVideo == 0 && resource_url.length > 0"
                >共 {{ resource_url.length }} 张图片，</span
              >还能上传 {{ 18 - resource_url.length }} 张图片<span
                v-if="isVideo == -1"
                >或 1 条视频</span
              >
            </div>
          </div>
        </div>
      </div>

      <div class="right">
        <div class="infoContainer">
          <p class="infoLabel">添加标题</p>
          <el-input
            v-model="title"
            placeholder="请输入标题文字（0-30字）"
            maxlength="30"
            show-word-limit
            autosize
            resize="none"
          ></el-input>
        </div>
        <div class="infoContainer">
          <p class="infoLabel">选择话题</p>
          <p class="openTopic" @click="insertTopic()">请选择话题</p>
        </div>
        <div class="infoContainer">
          <p class="infoLabel">添加链接</p>
          <el-input
            v-model="link"
            placeholder="请输入链接"
            maxlength="300"
            class="infoLink"
            type="textarea"
            autosize
            resize="none"
          ></el-input>
        </div>
        <div class="infoContainer" v-if="!mainId">
          <p class="infoLabel">选择位置</p>
          <div class="thumbTypeContainer">
            <div class="radioContainer">
              <el-radio v-model="isLocation" label="0">不设置</el-radio>
              <el-radio v-model="isLocation" label="1">设置</el-radio>
            </div>
            <br v-show="isLocation == 1" />
            <MapSelection
              v-show="isLocation == 1"
              ref="mapSelection"
              @confirm="handleLocationSelected"
            ></MapSelection>
            <el-input
              type="textarea"
              style="margin-top: 20px"
              :rows="2"
              placeholder="请输入位置"
              v-model="address"
              resize="none"
              maxlength="255"
              v-show="isLocation == 1"
            >
            </el-input>
          </div>
        </div>
        <div class="infoContainer">
          <p class="infoLabel">选择圈子</p>
          <el-select
            v-model="circleName"
            filterable
            remote
            reserve-keyword
            placeholder="请搜索圈子"
            :remote-method="getCircleList"
            :loading="circleLoading"
            @change="circlePick"
            class="circleSearch"
            clearable
            @clear="clearCircle"
          >
            <el-option
              v-for="item in circleList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
              class="circleSearchContain"
            >
              <img :src="item.avatar_url" class="circleHead" />
              <p class="circleName">{{ item.name }}</p>
            </el-option>
          </el-select>
        </div>
        <div class="infoContainer">
          <p class="infoLabel">允许赞赏</p>
          <div class="thumbTypeContainer">
            <div class="radioContainer">
              <el-radio v-model="allow_reward" label="1">是</el-radio>
              <el-radio v-model="allow_reward" label="0">否</el-radio>
            </div>
          </div>
        </div>
        <div class="infoContainer originalContainer">
          <p class="infoLabel">作品声明</p>
          <div class="thumbTypeContainer">
            <div class="radioContainer" style="display: inline-block">
              <el-radio
                v-for="(item, index) in originalList"
                :key="index"
                v-model="is_original"
                :label="item.is_original"
                >{{ item.desc }}</el-radio
              >
            </div>
          </div>
        </div>
      </div>

      <div class="btnContainer">
        <div class="innerBtnContainer">
          <div type="primary" class="submitBtn" @click="submitFn()">发布</div>
        </div>
      </div>
    </div>

    <el-dialog
      title="插入话题"
      :visible.sync="insertTopicVisible"
      width="600px"
      class="insertTopicContainer"
    >
      <el-select
        v-model="topicValue"
        filterable
        remote
        default-first-option
        placeholder="请输入或者选择话题"
        :remote-method="getTopicList"
        @change="topicInputChange"
      >
        <el-option
          v-for="item in topicOptions"
          :key="item.id"
          :label="item.title"
          :value="item.id"
          style="
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 550px;
          "
        >
          <span v-if="item.is_official == 1" style="color: #ea0e0e">(官方)</span
          >{{ item.title }}
        </el-option>
      </el-select>
      <div slot="footer" class="dialog-footer">
        <div class="submitBtn" @click="insertTopicVisible = false">取消</div>
        <div class="submitBtn" type="primary" @click="insertTopicFn">确定</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import NavBar from "../../components/NavBarForEdit";
import { NEWS_HOST, SWNEWS_HOST } from "../../constants/apiHosts";
import { HS_upload } from "./../../utils/huoshanUpload";
import { setToken } from "@/utils/libs/auth";
import MapSelection from "../../components/MapSelection/index.vue";

export default {
  data() {
    return {
      loading: false,
      mainId: "",
      title: "",
      content: "",
      isVideo: -1, //-1空,0图片,1视频
      resource_url: [],
      type: 6,
      circleList: [],
      circleId: "",
      circleName: "",
      circleLoading: false,
      topicIds: [],
      topicShowList: [],
      insertTopicVisible: false,
      topicOptions: [],
      topicValue: "",
      allow_reward: "0",
      link: "",
      isLocation: "0",
      mapLoading: false,
      mapShow: false,
      AMap: {},
      map: "",
      placeSearch: {},
      geocoder: {},
      searchMap: "",
      position: {},
      lon: "",
      lat: "",
      address: "",
      editorMain: {},
      setting: {
        language_url: require("@/assets/tinymce/langs/zh_CN.js"),
        language: "zh_CN", //以上两者都需要配置
        branding: false, //是否禁用Powered by TinyMCE
        menubar: false, //"tools table format view insert edit"
        toolbar: "",
        plugins: "paste",
        contextmenu: false, // 右键菜单
        content_style:
          "p,span{font-size: 18px !important;color: #333 !important;line-height: 25px !important; font-family: 'PingFang SC';}*{margin: 0 !important;}.topicName{color: #1687d9 !important;margin-right: 6px !important;display:inline-block;}body{padding:3px 0;}body::-webkit-scrollbar {width: 8px;height: 8px;background-color: #f5f5f5;border-radius: 2px;}body::-webkit-scrollbar-thumb {border-radius: 5px;background: rgba(0, 0, 0, 0.3);}body::-webkit-scrollbar-thumb:hover {border-radius: 3px;-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.55);background: rgba(0, 0, 0, 0.15);}",
        toolbar_drawer: false, // 工具栏全部展示
        valid_elements: "p,span[class|contenteditable|id],br",
        placeholder: "有什么想说的发帖和大家分享吧",
        paste_auto_cleanup_on_paste: true,
        paste_remove_styles: true,
        paste_remove_styles_if_webkit: true,
        paste_strip_class_attributes: true,
        paste_as_text: true,
      },
      is_original: "",
      originalList: [],
    };
  },
  components: {
    NavBar,
    MapSelection,
  },
  created() {
    if (this.$route.query.token) {
      setToken(this.$route.query.token);
      localStorage.setItem("token", this.$route.query.token);
    }

    this.getIsOriginalDesc();
  },
  mounted() {},
  methods: {
    setup(editor) {
      this.editorMain = editor;

      setTimeout(() => {
        if (this.$route.query.topicId) {
          this.editorMain.insertContent(
            `<span class="topicName" contenteditable="false" id="${this.$route.query.topicId}">#${this.$route.query.topicTitle}#</span>`
          );
          this.topicIds.push(this.$route.query.topicId);
        }
      }, 1000);
    },
    onBeforeUpload(file) {
      const isIMAGE = file.type.indexOf("image/") >= 0;
      const isVIDEO = file.type.indexOf("video/") >= 0;
      //const isLt1M = file.size / 1024 / 1024 < 1;

      if (this.isVideo == 0 && isVIDEO) {
        this.$message.error("请上传图片！");
        return false;
      } else if (!isIMAGE && !isVIDEO) {
        this.$message.error("请上传图片或视频！");
        return false;
      } else {
        this.loading = true;
        return true;
      }
      // if (!isLt1M) {
      //   this.$message.error("上传文件大小不能超过 1MB!");
      // } && isLt1M
    },
    uploadFn(val) {
      HS_upload(
        val.file,
        (data) => {
          console.log(data);
          if (val.file.type.indexOf("image/") >= 0) {
            this.resource_url.push({
              url: data.url,
              thumb: data.url,
            });
            this.isVideo = 0;
          } else {
            this.resource_url.push({
              url: data.videoUri,
              thumb: data.PosterUri,
            });
            this.isVideo = 1;
          }

          this.loading = false;
        },
        (error) => {
          console.log("error:" + error);
        },
        (processPercent) => {
          console.log("processPercent:" + processPercent);
        }
      );
    },
    graphDelete(index) {
      this.$confirm("确定要删除该素材吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.resource_url.splice(index, 1);

          if (this.resource_url.length == 0) {
            this.isVideo = -1;
          }
        })
        .catch(() => {});
    },
    insertTopic() {
      this.topicValue = "";
      this.getTopicList("");
      this.insertTopicVisible = true;
    },
    getTopicList(keyword) {
      this.$axios
        .get(
          `${SWNEWS_HOST}/api/hottopic/search?title=${keyword}&page=1&size=50`
        )
        .then((res) => {
          if (res.data.code == 0) {
            res.data.data.forEach((element) => {
              element.title = element.title.replace(/#/gi, "");
              if (element.id == 0) {
                element.title += "--点击添加新话题";
                element.id = element.title;
              }
            });
            this.topicOptions = res.data.data;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    topicInputChange(val) {
      if (typeof this.topicValue == "string") {
        this.topicValue = this.topicValue.replace(/--点击添加新话题/gi, "");
      }
    },
    insertTopicFn() {
      if (typeof this.topicValue == "string" && this.topicValue == "") {
        this.$message({
          message: "话题不能为空",
          type: "warning",
        });
      } else if (typeof this.topicValue == "string") {
        if (this.topicValue.length > 30) {
          this.$message({
            message: "话题长度不能超过30个字",
            type: "warning",
          });
          return;
        }
        this.$axios
          .post(`${NEWS_HOST}/api/hottopic/add`, {
            title: "#" + this.topicValue + "#",
          })
          .then((res) => {
            if (res.data.code == 0) {
              if (this.checkTopic(res.data.data.id)) {
                this.$message({
                  message: "不能添加重复话题",
                  type: "warning",
                });
              } else {
                this.editorMain.insertContent(
                  `<span class="topicName" contenteditable="false" id="${res.data.data.id}">#${this.topicValue}#</span>`
                );

                this.topicIds.push(res.data.data.id);

                this.insertTopicVisible = false;
              }
            } else {
              this.$message.error(res.data.msg);
            }
          });
      } else if (this.checkTopic(this.topicValue)) {
        this.$message({
          message: "不能添加重复话题",
          type: "warning",
        });
      } else {
        this.topicOptions.forEach((item) => {
          if (item.id == this.topicValue) {
            this.editorMain.insertContent(
              `<span class="topicName" contenteditable="false" id="${
                item.id
              }">#${item.title.replace(/#/gi, "")}#</span>`
            );

            this.topicIds.push(this.topicValue);

            this.insertTopicVisible = false;
          }
        });
      }
    },
    checkTopic(id) {
      let topicIdsNow = [];
      let tinymce = document.getElementsByClassName("tox-edit-area__iframe")[0];
      let editorElem =
        tinymce.contentDocument.getElementsByClassName("topicName");
      if (editorElem.length > 0) {
        editorElem = Array.from(editorElem);
        editorElem.forEach((elem, index) => {
          topicIdsNow.push(elem.getAttribute("id"));
        });
      }
      return topicIdsNow.indexOf(id + "") > -1;
    },
    getTopics(global_id) {
      this.$axios
        .get(
          `${NEWS_HOST}/api/hottopic/getTopicListByManuscriptId?global_id=${global_id}`
        )
        .then((res) => {
          if (res.data.code == 0) {
            res.data.data.forEach((item) => {
              this.topicIds.push(item.id);
            });
            this.topicShowList = res.data.data;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    handleLocationSelected(location) {
      this.lat = location.lat;
      this.lon = location.lng;
      this.address =
        location.province +
        location.city +
        location.district +
        location.address +
        location.name;
      this.$refs.mapSelection.setLocation(null);
    },
    mapShowFn() {
      this.mapShow = true;
      // if (!this.map) {
      //   this.$nextTick(function () {
      //     this.map = new AMap.Map("container", {
      //       zoom: 12,
      //     });

      //     var center = this.map.getCenter();
      //     if (center.lng && center.lat) {
      //       this.map.setCenter([center.lng, center.lat]);
      //       this.lon = center.lng;
      //       this.lat = center.lat;
      //     }

      //     this.map.on("click", (evt) => {
      //       this.geocoder.getAddress(
      //         [evt.lnglat.lng, evt.lnglat.lat],
      //         (status, result) => {
      //           if (status === "complete" && result.info === "OK") {
      //             this.lon = evt.lnglat.lng;
      //             this.lat = evt.lnglat.lat;
      //             this.address = result.regeocode.formattedAddress;

      //             this.mapShow = false;
      //           } else {
      //             console.log(status, result);
      //           }
      //         }
      //       );
      //     });

      //     this.AMap.plugin("AMap.PlaceSearch", () => {
      //       this.placeSearch = new AMap.PlaceSearch({
      //         pageSize: 20, // 单页显示结果条数
      //         pageIndex: 1, // 页码
      //         map: this.map, // 展现结果的地图实例
      //         panel: "panel", // 结果列表将在此容器中进行展示。
      //         autoFitView: true, // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
      //       });
      //       this.AMap.Event.addListener(
      //         this.placeSearch,
      //         "markerClick",
      //         (e) => {
      //           this.lon = e.data.location.lng;
      //           this.lat = e.data.location.lat;
      //           this.address =
      //             e.data.pname +
      //             e.data.cityname +
      //             e.data.adname +
      //             e.data.address +
      //             e.data.name;

      //           this.mapShow = false;
      //         }
      //       );
      //       this.AMap.Event.addListener(
      //         this.placeSearch,
      //         "listElementClick",
      //         (e) => {
      //           this.lon = e.data.location.lng;
      //           this.lat = e.data.location.lat;
      //           this.address =
      //             e.data.pname +
      //             e.data.cityname +
      //             e.data.adname +
      //             e.data.address +
      //             e.data.name;

      //           this.mapShow = false;
      //         }
      //       );
      //     });
      //   });
      // }
    },
    searchMapFn() {
      if (!this.searchMap) {
        this.$message("请输入搜索地址");
      } else {
        this.placeSearch.search(
          this.searchMap,
          //[this.lon, this.lat],
          //50000,
          (status, result) => {
            if (status === "complete" && result.info === "OK") {
            } else {
              console.log(status, result);
            }
          }
        );
      }
    },
    mapOpen() {
      this.searchMap = "";
    },
    getCircleList(query) {
      this.$axios
        .post(`${SWNEWS_HOST}/api/communityCircle/getCircleList`, {
          name: query,
          page: 1,
          size: 100,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.circleLoading = true;
            setTimeout(() => {
              this.circleLoading = false;
              this.circleList = res.data.data.filter((item) => {
                return (
                  item.name.toLowerCase().indexOf(query.toLowerCase()) > -1
                );
              });
            }, 200);
          } else {
            this.$message.error(res.data.msg || res.data.data);
          }
        });
    },
    circlePick(e) {
      this.circleList.forEach((item) => {
        if (item.id == e) {
          this.circleId = item.id;
          this.circleName = item.name;
        }
      });
    },
    clearCircle() {
      this.circleId = "";
      this.circleName = "";
    },
    submitFn() {
      if (this.content == "" && this.resource_url.length == 0) {
        this.$message({
          message: "正文，图片/视频不能同时为空",
          type: "warning",
        });
      } else if (this.isLocation == 1 && this.address == "") {
        this.$message({
          message: "请打开地图选择位置",
          type: "warning",
        });
      } else {
        let request = {
          title: this.title,
          content: this.content
            .replace(/<p>/g, "")
            .replace(/<\/p>/g, "\n")
            .replace(/<br \/>/g, "\n")
            .replace(/<br>/g, "\n")
            .replace(/\n\n/g, "\n")
            .replace(
              /<span class="topicName" contenteditable="false" id=".+">/g,
              ""
            )
            .replace(/<span class="topicName" contenteditable="false">/g, "")
            .replace(/<\/span>/g, "")
            .replace(/&nbsp;/g, " ")
            .replace(/&ldquo;/g, "“")
            .replace(/&rdquo;/g, "”")
            .replace(/&hellip;/g, "…"),
          type:
            this.isVideo == -1 ? "text" : this.isVideo == 0 ? "image" : "video",
          circle_id: this.circleId,
          link_url: this.link,
          location: this.isLocation == 0 ? "" : this.address,
          reward: this.allow_reward,
          lng: this.lon || "",
          lat: this.lat || "",
        };
        if (this.mainId) {
          request.post_id = this.mainId;
        }
        if (this.is_original) {
          request.is_original = this.is_original;
        }
        if (this.resource_url.length) {
          let resource_urls = [];
          this.resource_url.forEach((item) => {
            resource_urls.push(item.url);
          });
          request.resource_url = resource_urls.join("|");
          request.cover_url =
            this.isVideo == 1
              ? this.resource_url[0].thumb
              : resource_urls.join("|");
        }
        this.$axios
          .post(
            `${SWNEWS_HOST}${
              this.mainId
                ? "/api/communityMyPost/editPost"
                : "/api/communityMyPost/addPost"
            }`,
            request
          )
          .then((res) => {
            if (res.data.code == 0) {
              this.$router.push({
                path: "/personalScript",
              });
            } else {
              this.$message.error(res.data.msg || res.data.data);
            }
          });
      }
    },
    getPostDetail() {
      this.$axios
        .post(`${SWNEWS_HOST}/api/communityPost/getPostDetail`, {
          encode_nid: this.$route.query.nid,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.mainId = res.data.data.id;
            this.title = res.data.data.title;
            const regex = /#[^#]+#/g;
            const matches = res.data.data.content.match(regex);
            if (matches) {
              matches.forEach((item) => {
                var regexp = new RegExp(item, "gi");
                res.data.data.content = res.data.data.content.replace(
                  regexp,
                  `<span class="topicName" contenteditable="false">${item}</span>`
                );
              });
            }
            res.data.data.content = res.data.data.content.replace(
              /\n/g,
              "<br>"
            );
            this.content = res.data.data.content;
            this.isVideo =
              res.data.data.type == "text"
                ? -1
                : res.data.data.type == "image"
                ? 0
                : 1;
            this.circleId =
              res.data.data.community_circle_id == "0"
                ? ""
                : res.data.data.community_circle_id;
            this.circleName = res.data.data.circle_name;
            this.link = res.data.data.link_url;
            this.address = res.data.data.location;
            if (this.address) {
              this.isLocation = "1";
            }
            this.allow_reward = res.data.data.reward + "";
            if (res.data.data.resource_url.length) {
              res.data.data.resource_url.forEach((item) => {
                if (item.indexOf(".mp4") >= 0) {
                  this.resource_url.push({
                    url: item,
                    thumb: res.data.data.cover_url[0],
                  });
                } else {
                  this.resource_url.push({
                    url: item,
                    thumb: item,
                  });
                }
              });
            }
            this.is_original = res.data.data.is_original || "";
          } else {
            this.$message.error(res.data.msg || res.data.data);
          }
        });
    },
    getMyPostDetail() {
      this.$axios
        .post(`${SWNEWS_HOST}/api/communityMyPost/getMyPostDetail`, {
          id: this.$route.query.id,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.mainId = res.data.data.id;
            this.title = res.data.data.title;
            const regex = /#[^#]+#/g;
            const matches = res.data.data.content.match(regex);
            if (matches) {
              matches.forEach((item, index) => {
                var regexp = new RegExp(item, "gi");
                res.data.data.content = res.data.data.content.replace(
                  regexp,
                  `<span class="topicName" contenteditable="false" id="${res.data.data.hottopic_list[index].id}">${item}</span>`
                );
              });
            }
            res.data.data.content = res.data.data.content.replace(
              /\n/g,
              "<br>"
            );
            this.content = res.data.data.content;
            this.isVideo =
              res.data.data.type == "text"
                ? -1
                : res.data.data.type == "image"
                ? 0
                : 1;
            this.circleId =
              res.data.data.community_circle_id == "0"
                ? ""
                : res.data.data.community_circle_id;
            this.circleName = res.data.data.circle_name;
            this.link = res.data.data.link_url;
            this.address = res.data.data.location;
            if (this.address) {
              this.isLocation = "1";
            }
            this.allow_reward = res.data.data.reward + "";
            if (res.data.data.resource_url.length) {
              res.data.data.resource_url.forEach((item) => {
                if (item.indexOf(".mp4") >= 0) {
                  this.resource_url.push({
                    url: item,
                    thumb: res.data.data.cover_url[0],
                  });
                } else {
                  this.resource_url.push({
                    url: item,
                    thumb: item,
                  });
                }
              });
            }
            this.is_original = res.data.data.is_original || "";
          } else {
            this.$message.error(res.data.msg || res.data.data);
          }
        });
    },
    getIsOriginalDesc() {
      this.$axios
        .get(`${SWNEWS_HOST}/api/news/getIsOriginalDesc`)
        .then((res) => {
          if (res.data.code == 0) {
            this.originalList = res.data.data;

            this.$nextTick(() => {
              if (this.$route.query.id && this.$route.query.id != 0) {
                this.getMyPostDetail();
              } else if (this.$route.query.nid) {
                this.getPostDetail();
              }
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
  },
};
</script>

<style lang="scss">
.circleSearchContain {
  display: flex;
  align-items: center;

  .circleHead {
    width: 28px;
    height: 28px;
    margin-right: 6px;
  }
}
</style>

<style lang="scss" scoped>
.mainContainer {
  background: #edf1f8;

  .innerContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
    background: #edf1f8;

    /deep/.editContainer {
      margin: 20px auto 0 auto;
      background: white;
      position: relative;
      width: 856px;
      padding: 56px 40px 32px 40px;

      .titleLabel {
        color: #333333;
        font-family: "PingFang SC";
        font-size: 26px;
        font-weight: 400;
        line-height: 36px;
      }

      .el-textarea {
        margin-bottom: 20px;

        textarea {
          min-height: 36px !important;
          border: 0;
          border-bottom: 1px solid #e5e6eb;
          border-radius: 0;
          color: #333333;
          font-family: "PingFang SC";
          font-size: 26px;
          font-weight: 400;
          padding: 20px 60px 20px 0;
          overflow-y: hidden;
          background-color: #fff;
        }

        .el-input__count {
          color: #999999;
          font-family: "PingFang SC";
          font-size: 18px;
          font-weight: 400;
          top: 30px;
        }
      }

      .tox-tinymce {
        border: 0px !important;
        height: 400px !important;
      }

      .tox-statusbar {
        border-top: 0px !important;
        display: none !important;
      }

      .sourceListContainer {
        width: 100%;
        padding-top: 32px;
        border-top: 1px solid #e5e6eb;
        display: flex;

        .inputLabel {
          width: 70px;
          color: #333333;
          font-family: "PingFang SC";
          font-size: 14px;
          font-weight: bold;
          line-height: 20px;
          text-align: right;
          margin-right: 30px;
          flex-shrink: 0;
        }

        .imgCount {
          color: #666666;
          font-family: "PingFang SC";
          font-size: 12px;
          font-weight: 400;
          line-height: 17px;
        }
      }

      .uploadElemBox {
        width: 100%;
        height: 100%;

        .el-upload {
          width: 100%;
          height: 100%;
          overflow: hidden;

          .el-upload-dragger {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
          }
        }

        .el-upload-list {
          display: none;
        }
      }

      .graphList {
        display: flex;
        flex-wrap: wrap;
        padding-top: 5px;

        li {
          width: 124px;
          margin: 0 14px 14px 0;

          &:nth-child(5n) {
            margin-right: 0;
          }

          .thumbContainer {
            width: 100%;
            height: 93px;
            object-fit: cover;
            position: relative;

            .thumb {
              width: 100%;
              height: 100%;
              border-radius: 6px;
            }

            .deleteFn {
              width: 27px;
              position: absolute;
              right: 0;
              top: 0;
              cursor: pointer;
            }

            .videoIcon {
              width: 30px;
              height: 30px;
              position: absolute;
              right: 47px;
              top: 32px;
            }
          }
        }
      }
    }

    .right {
      width: 856px;
      padding: 32px 40px 24px 40px;
      background: white;
      margin-bottom: 88px;

      .infoContainer {
        display: flex;
        align-items: center;
        margin-bottom: 32px;
      }

      .originalContainer {
        align-items: flex-start;

        .el-radio {
          padding-bottom: 32px;
        }

        /deep/.el-radio__inner {
          border-radius: 3px;
        }
      }

      .infoLabel {
        width: 70px;
        color: #333333;
        font-family: "PingFang SC";
        font-size: 14px;
        font-weight: bold;
        line-height: 20px;
        flex-shrink: 0;
        text-align: right;
        margin-right: 30px;
      }

      .openTopic {
        width: 290px;
        border-radius: 4px;
        background: #f6f7f9;
        color: #bbb;
        font-family: "PingFang SC";
        font-size: 14px;
        font-weight: 400;
        line-height: 40px;
        padding: 0 20px;
        cursor: pointer;
      }

      .infoLink {
        /deep/input {
          border-radius: 4px;
          background: #f6f7f9;
          border: 0;
          color: #333333;
          font-family: "PingFang SC";
          font-size: 14px;
          font-weight: 400;
          padding: 0 20px;
        }
      }

      .circleSearch {
        width: 290px;

        /deep/.el-input__inner {
          padding-left: 20px;
          border-radius: 4px;
          background: #f6f7f9;
          border: 0;
          color: #333333;
          font-family: "PingFang SC";
          font-size: 14px;
          font-weight: 400;
        }
      }

      .chooseLocation {
        width: 100px;
        margin: 10px 0;
        border: 1px solid #dcdfe6;
        cursor: pointer;
        text-align: center;
        font-size: 14px;
        border-radius: 4px;
        line-height: 36px;
        background-color: #ea0e0e;
        border-color: #ea0e0e;
        color: #fff;
      }

      .el-textarea {
        width: 290px;

        /deep/textarea {
          border-radius: 4px;
          background: #f6f7f9;
          border: 0;
          color: #333333;
          font-family: "PingFang SC";
          font-size: 14px;
          font-weight: 400;
          padding: 10px 20px;
        }
      }

      /deep/.el-input {
        margin: 0 !important;

        input {
          border-radius: 4px;
          background: #f6f7f9;
          border: 0;
          color: #333333;
          font-family: "PingFang SC";
          font-size: 14px;
          font-weight: 400;
          padding: 0 20px;
        }

        .el-input__count-inner {
          background: #f6f7f9;
        }
      }
    }

    .btnContainer {
      width: 100%;
      height: 72px;
      background: #fff;
      position: fixed;
      left: 0;
      bottom: 0;
      box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

      .innerBtnContainer {
        width: 856px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin: 0 auto;
      }

      .submitBtn {
        width: 122px;
        border: 1px solid #dcdfe6;
        cursor: pointer;
        text-align: center;
        font-size: 14px;
        border-radius: 4px;
        line-height: 36px;
        display: inline-block;
        background-color: #ea0e0e;
        border-color: #ea0e0e;
        color: #fff;
      }
    }
  }

  /deep/.insertTopicContainer {
    .el-dialog__body {
      padding-bottom: 10px;
      padding-top: 10px;
    }
    .el-select {
      width: 100%;
    }
    .el-input {
      width: 100%;
      margin-bottom: 0;
    }
    .el-input__inner {
      width: 100%;
    }

    .submitBtn {
      width: 80px;
      border: 1px solid #dcdfe6;
      cursor: pointer;
      text-align: center;
      font-size: 14px;
      border-radius: 4px;
      color: #333;
      line-height: 36px;
      display: inline-block;
      margin-left: 12px;
    }

    .submitBtn[type="primary"] {
      width: 80px;
      background-color: #ea0e0e;
      border-color: #ea0e0e;
      color: #fff;
    }
  }

  .mapContainer {
    /deep/.el-dialog__body {
      padding-top: 10px;
      position: relative;

      #container {
        margin-top: 20px;
        widows: 100%;
        height: 500px;
      }

      .searchMap {
        width: 70% !important;
        max-width: 600px;
        margin-right: 20px;

        .el-input__inner {
          width: 100%;
        }
      }

      #panel {
        position: absolute;
        background-color: white;
        max-height: 500px;
        overflow-y: auto;
        top: 80px;
        right: 10px;
        width: 280px;
      }
    }

    .submitBtn {
      width: 80px;
      border: 1px solid #dcdfe6;
      cursor: pointer;
      text-align: center;
      font-size: 14px;
      border-radius: 4px;
      color: #333;
      line-height: 36px;
      display: inline-block;
      margin-left: 12px;
    }

    .submitBtn[type="primary"] {
      width: 80px;
      background-color: #ea0e0e;
      border-color: #ea0e0e;
      color: #fff;
    }
  }
}
</style>
